<template>
  <div class="main"></div>
</template>

<script>
import router from "../../router";
import config from "@/utils/config";
export default {
  name: "wx-index",
  data() {
    return {};
  },
  created() {
    console.info("wx redirect create ...");
    this.wxLogin();
  },
  methods: {
    wxLogin() {
      let _this = this;
      const query = this.$route.query;
      let code = query.code;
      let state = query.state;
      let channel = query.channel;
      console.info("index redirect create = " + query);
      if (!code) {
        code = this.getQueryVariable("code");
        state = this.getQueryVariable("state");
        channel = this.getQueryVariable("channel");
      }
      console.info("state == " + state + "; a == " + code + "; c = " + channel);
      if (!state || state === undefined || state === "undefined") {
        state = encodeURIComponent(
          JSON.stringify({
            type: 1
          })
        );
      }
      console.info("channel = " + channel + "; code = " + code);
      if (code) {
        const _this = this;
        this.$api
          .authLogin({
            code: code,
            state: state,
            appid: config.getAppId()
          })
          .then(res => {
            console.log(res);
            if (res.errcode === 0) {
              if (res.status === 0) {
                // 需要账号密码登录
                _this.$router.push({ name: "login", params: { key: res.key } });
                return;
              }
              localStorage.setItem("token", res.key);
              _this.$router.push({ path: "/live" });
            } else {
              // 其他异常
              _this.$toast.clear();
              _this.$toast(this.$t("common.nodata"));
            }
          })
          .catch(err => {
            // 其他异常
            console.log(err);
            _this.$toast.clear();
            _this.$toast(this.$t("common.timeout"));
          });
      }
    },
    getQueryVariable(variable) {
      const query = window.location.search.substring(1);
      const vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] === variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>
